import { RouteObject } from 'react-router-dom'
import LoginComponent from '@/components/LoginComponent/LoginComponent'

const LoginRoute: RouteObject = {
  path: '/login',
  element: <LoginComponent />,
}

export default LoginRoute
